import { useState, useEffect, useRef } from "react";
import styles from "./FeaturePicker.module.css";

type SearchBarProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  resultsCount: number;
};

export function SearchBar({ value, onChange, disabled = false, resultsCount }: SearchBarProps) {
  const [localValue, setLocalValue] = useState(value);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newValue = event.target.value;
    setLocalValue(newValue);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      onChange(newValue);
    }, 300);
  }

  function handleClear() {
    setLocalValue("");
    onChange("");
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const showClearButton = localValue.length > 0;

  return (
    <div className={styles.searchBar}>
      <div className={styles.searchInputWrapper}>
        <input
          type="text"
          className={styles.searchInput}
          placeholder="Search features..."
          value={localValue}
          onChange={handleInputChange}
          disabled={disabled}
          aria-label="Search features"
        />
        {showClearButton && (
          <button
            type="button"
            className={styles.clearButton}
            onClick={handleClear}
            disabled={disabled}
            aria-label="Clear search"
          >
            ✕
          </button>
        )}
      </div>
      {value && (
        <div className={styles.searchResults}>
          {resultsCount} {resultsCount === 1 ? "result" : "results"}
        </div>
      )}
    </div>
  );
}
